"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Expand = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const Button_1 = require("../Button");
/**
 * Convert the is expanded state into an Icon.
 */
function isExpandedToIcon(isExpanded) {
    return isExpanded ? Icon_1.Icon.CaretCircleDown : Icon_1.Icon.CaretCircleRight;
}
const Expand = ({ isExpanded, onClick, }) => {
    const ExpandIcon = react_1.default.useMemo(() => {
        return isExpandedToIcon(isExpanded);
    }, [isExpanded]);
    return ((0, jsx_runtime_1.jsx)(Button_1.Button.Icon, { Icon: ExpandIcon, onClick: () => onClick(isExpanded) }));
};
exports.Expand = Expand;
